import { councilTheme, mantineCssVariableResolver } from '@/council/theme';
import { MantineProvider } from '@mantine/core';
import { createFileRoute, Outlet } from '@tanstack/react-router';

function RouteComponent() {
	return (
		<MantineProvider theme={councilTheme} cssVariablesResolver={mantineCssVariableResolver}>
			<Outlet />
		</MantineProvider>
	);
}

export const Route = createFileRoute('/council')({
	component: RouteComponent,
});
